import type { Action } from 'redux';
import NotificationActions from '../../../../main/actions/NotificationActions';
import { getPartnerName } from '../../../../main/components/PartnerManager/utils';
import dash_api from '../../../../main/support/dash_api';
import type { AdPartner } from '../../../../main/types/adPartnerTypes';
import { ReduxAsyncAction } from '../../../services/ReduxAsyncAction';
import type { DisablePartnerRequestActionPayload } from '../AdPartner.types';

const DisablePartner = new ReduxAsyncAction<'AD_PARTNER_DISABLE', DisablePartnerRequestActionPayload, AdPartner>(
  'AD_PARTNER_DISABLE'
);

DisablePartner.registerRequest(async ({ partner }) => {
  const { data } = await dash_api.put<AdPartner>(`/v1/ad-networks/app`, {
    partner: { ...partner, enabled: false },
  });

  data.machine_name = partner.machine_name;
  NotificationActions.showNotification(`${getPartnerName(partner)} has been disabled`, 'success');
  return data;
});

export const DISABLE = DisablePartner.actionNamespaceConstants;

export const disablePartner = DisablePartner.request;

export type DisablePartnerResponseAction = Action<typeof DISABLE.response> & { data: AdPartner };
